export enum ColumnId {
  ServiceItem = 'serviceItem',
  Global = 'global',
  Hidden = 'hidden',
  LastUpdatedBy = 'lastUpdatedBy',
  ServiceType = 'serviceType',
  Version = 'version',
  VersionCreated = 'versionCreated',
  Courtesy = 'courtesy',
  PriceType = 'priceType',
  SupportingItems = 'supportingItems',
  Price = 'price',
  ProPrice = 'proPrice',
  Actions = 'actions',
}

export type InventoryColumnDetails = {
  id: ColumnId
  header: string
  align: 'left' | 'right' | 'center'
}

export const InventoryTableColumns: InventoryColumnDetails[] = [
  {
    id: ColumnId.ServiceItem,
    header: 'Service Item',
    align: 'left',
  },
  {
    id: ColumnId.Global,
    header: 'Global',
    align: 'center',
  },
  {
    id: ColumnId.Hidden,
    header: 'Hidden',
    align: 'center',
  },
  {
    id: ColumnId.LastUpdatedBy,
    header: 'Last updated by',
    align: 'left',
  },
  {
    id: ColumnId.ServiceType,
    header: 'Service type',
    align: 'left',
  },
  {
    id: ColumnId.Version,
    header: 'Version',
    align: 'center',
  },
  {
    id: ColumnId.VersionCreated,
    header: 'Version created',
    align: 'left',
  },
  {
    id: ColumnId.Courtesy,
    header: 'Courtesy',
    align: 'center',
  },
  {
    id: ColumnId.PriceType,
    header: 'Price type',
    align: 'left',
  },
  {
    id: ColumnId.SupportingItems,
    header: 'Supporting Items',
    align: 'center',
  },
  {
    id: ColumnId.Price,
    header: 'Price',
    align: 'right',
  },
  {
    id: ColumnId.ProPrice,
    header: 'Pro price',
    align: 'right',
  },
  {
    id: ColumnId.Actions,
    header: '',
    align: 'right',
  },
]
